export default {
    data() {
        return {
            // 默认选中的菜单项，1是我的项目，3是个人信息，4是密码管理，5是更换风格
            activeIndex: '1',
            // 个人信息
            userInfo: {
                name: '',
                idcard: '',
                email: '',
                company: '',
            },
            // 项目数组
            projectList: [],
            // 图片前缀
            imgUrl: this.imgUrl,
            // 密码信息
            passwordInfo: {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
            // 个人中心风格
            styleIndex: 2,
			// 我的风格列表
			styleList:[
				require('@/assets/images/personalcenter.png'),
				require('@/assets/images/personalcenter1.png'),
				require('@/assets/images/personalcenter2.png'),
			],
        }
    },
    methods: {
		//更换风格
		currentStyleButton(){
			this.$post('users/style_current',{
				my_style:this.styleIndex,
				token:this.$store.state.id
			}).then(res=>{
				this.$store.state.my_style = this.styleIndex
				if(this.styleIndex == 0 ){
					this.$router.push('/personalcenter')
				}
				if(this.styleIndex == 1 ){
					this.$router.push('/personalcenter1')
				}
			})
			
		},
        // 切换菜单栏时调用，index时当前选择的菜单项的标识
        handleSelect(index) {
            this.activeIndex = index;
        },

        // 获取个人信息
        getUserInfo() {
            this.$post('users/profile', {
                token: this.$store.state.id
            }).then(res => {
                this.userInfo = res.data.result;

                // 如果用户的姓名或身份证号已经有值，就不让修改
                if (!this.$isAbnormal(this.userInfo.name.trim())) {
                    this.$refs.name.$el.innerText = this.userInfo.name;
                }
                if (!this.$isAbnormal(this.userInfo.idcard.trim())) {
                    this.$refs.idcard.$el.innerText = this.userInfo.idcard;
                }
            })
        },

        // 获取已有项目数据
        getData() {
            this.$post('purchased/search_pay_all', {
                token: this.$store.state.id,
                offset: 0,
                length: 999,
            }).then(res => {
                this.projectList = res.data.result.data;
            })
        },

        // 处理进度
        handleProgress(progress) {
            return (progress * 100).toFixed(2) * 1;
        },

        // 前往学习页面
        toStudy(id, is_project) {
            this.$toClass(id, is_project);
        },

        // 保存个人信息
        saveUserInfo() {
            // 验证邮箱
            let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            if (!this.$isAbnormal(this.userInfo.email) && !reg.test(this.userInfo.email)) {
                this.$message.error('邮箱格式错误！');
                this.userInfo.email = '';
                return;
            }

            // 确认提示再进行保存
            this.$confirm('姓名，身份证一旦填写不能修改，请确认信息无误后点击确定?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.save();
            }).catch(() => {
                this.$message.info('已取消修改信息');
            });
        },

        // 保存
        save() {
            this.$post('users/edit', {
                token: this.$store.state.id,
                name: this.userInfo.name.trim(),
                email: this.userInfo.email.trim(),
                company: this.userInfo.company.trim(),
                idcard: this.userInfo.idcard.trim(),
            }).then(res => {
                if (res.data.status === 'fail') {
                    this.$message.error('修改失败，请稍后重试');
                } else {
                    this.$message.success('修改成功');
                    this.getUserInfo();
                }
            })
        },

        // 修改密码
        editPassword() {
            // 验证
            if (this.$isAbnormal(this.passwordInfo.oldPassword.trim())) {
                this.$message.error('请输入旧密码');
                return;
            }
            if (this.$isAbnormal(this.passwordInfo.newPassword.trim())) {
                this.$message.error('请输入新密码');
                return;
            }
            if (this.$isAbnormal(this.passwordInfo.confirmPassword.trim())) {
                this.$message.error('请输入确认密码');
                return;
            }
            if (this.passwordInfo.newPassword.trim() !== this.passwordInfo.confirmPassword.trim()) {
                this.$message.error('新密码与确认密码不一致');
                return;
            }
            // 修改密码
            this.edit();
        },

        // 修改
        edit() {
            this.$post('users/setpswd', {
                token: this.$store.state.id,
                opassword: this.passwordInfo.oldPassword,
                password: this.passwordInfo.newPassword
            }).then(res => {
                if (res.data.status === 'fail') {
                    this.$message.error('旧密码不正确');
                } else {
                    this.$message.success('修改密码成功');
                    this.passwordInfo = {
                        oldPassword: '',
                        newPassword: '',
                        confirmPassword: '',
                    }
                }
            })
        },

        // 更换风格
        changeStyle(index) {
            this.styleIndex = index
        }
    },

    created() {
        // 获取个人信息
        this.getUserInfo();
        // 获取已有项目数据
        this.getData();
    },

    mounted() {
        document.title = '个人中心';
    }
}